import React from 'react'
import Loader from '../Common/Loader/Loader';
import Link from '../Link/Link';
import { useIntl, FormattedMessage } from 'react-intl';
import cx from "classnames";
import messages from '../../locale/messages';
import withStyles from 'isomorphic-style-loader/withStyles';
import { AngleLeftArrowIcon } from '../Common/Assets/SVGIcon/CommonSvgIcon';
import CardForm from '../CardForm/CardForm';
import { ElementsConsumer } from '@stripe/react-stripe-js';

import bt from "../../components/commonStyle.css";
import s from "./AddWalletForm.css"
import history from '../../history';

function AddWalletForm(props) {
    const { paymentMethodLoading, paymentMethods, userPaymentMethod, orderId, bookingId } = props
    const intl = useIntl()
    const enabledPaymentMethods = paymentMethods && paymentMethods?.getAllPaymentMethods?.results?.filter(method => method.isEnable) || [];
    const stripe = enabledPaymentMethods && enabledPaymentMethods?.find(o => o.id === 2) || null
    const paypal = enabledPaymentMethods && enabledPaymentMethods?.find(o => o.id === 5) || null

    const isPaymentId = stripe?.id || paypal?.id || null;
    const walletAmount = userPaymentMethod?.getPaymentMethod?.result?.walletBalance;
    let initialValues;

    if (!paymentMethodLoading) {
        initialValues = {
            paymentType: String(isPaymentId)
        }
    }
    const handleClick = () => {
        orderId
            ? history.push(`/order/${orderId}`)
            : (bookingId
                ? history.push(`/tracking/${bookingId}`)
                : history.push('/payment-method'));
    }

    return (
        <div className={s.addWalletWrapper}>
            <div className={s.addWalletSectionTitle}>
                <FormattedMessage {...messages.addWallet} />
                <div onClick={handleClick} className={cx(bt.customLink, 'customLinkRtl')}> <AngleLeftArrowIcon />{intl.formatMessage(messages.goBack)}</div>
            </div>
            <ElementsConsumer>
                {({ stripe, elements }) => <CardForm stripe={stripe}
                    elements={elements}
                    enabledPaymentMethods={enabledPaymentMethods}
                    isPaymentId={isPaymentId}
                    orderId={orderId}
                    amount={walletAmount}
                    isWallet
                    initialValues={initialValues}
                    bookingId={bookingId}
                    paymentMethodLoading={paymentMethodLoading}
                />}
            </ElementsConsumer>
        </div>
    )
}

export default withStyles(bt, s)(AddWalletForm);